import {
    AppBar,
    Toolbar,
    Box,
    IconButton,
    Tooltip,
    Link,
    useMediaQuery,
    Menu,
    MenuItem,
    ListItemIcon
} from '@material-ui/core';
import {
    Menu as MenuIcon,
    ContactSupport as ContactSupportIcon,
    Timeline as TimelineIcon,
    MoreVert as MoreVertIcon
} from '@material-ui/icons';
import './style.scss';
import SidebarContext from '../../Contexts/SidebarContext';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import AuthGuard from '../../../../components/AuthGuard';
import * as userPermissions from '../../../../consts/userRoles';
import LanguagePopover from '../../../../components/dashboard/LanguagePopover';
import AccountPopover from '../../../../components/dashboard/AccountPopover';
import { useTranslation } from 'react-i18next';
import GoodHabitzWhite from '../../../../icons/GoodHabitz_white.svg';
import GoodHabitzBlack from '../../../../icons/GoodHabitz_black.svg';
import { useState, useContext } from 'react';

const TopBar = () => {
    const { handleToggleSidebar } = useContext(SidebarContext);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isMobile = useMediaQuery('(max-width:998px)');
    const [mobileMenuAnchorEl, setMobileMenuAnchorEl] = useState(null);

    const toggleMobileMenu = (el) => {
        setMobileMenuAnchorEl(el);
    }

    return (
        <AppBar
            position="static"
            sx={{
                boxShadow: "initial"
            }}
        >
            <Toolbar
                className="LJ_Toolbar"
                sx={{
                    px: isMobile ? "8px !important" : 2
                }}
            >
                <Box
                    className="leftSection"
                >
                    <IconButton
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={() => handleToggleSidebar()}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Link
                        component={RouterLink}
                        to="/"
                        className="LJ_logo"
                    >
                        <img
                            alt="VDA Academy - Learning Journey"
                            src="data:image/svg+xml;base64,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"
                        />
                    </Link>
                </Box>
                <Box
                    className="rightSection"
                >
                    {
                        !isMobile &&
                        <>
                            <Link
                                component={RouterLink}
                                to="#"
                                onClick={(e) => {
                                    window.open("https://my.goodhabitz.com/sso/vieira", '_blank');
                                    e.preventDefault();
                                }}
                            >
                                <div style={{ width: "24px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Tooltip
                                        title={t('LJ:GoodHabitz')}
                                    >
                                        <div>
                                            <img
                                                style={{
                                                    color: "white",
                                                    width: "1em",
                                                    height: "1em"
                                                }}
                                                src={GoodHabitzWhite}
                                                alt="GoodHabitz"
                                            />
                                        </div>
                                    </Tooltip>
                                </div>
                            </Link>
                            <Link
                                component={RouterLink}
                                to="#"
                                onClick={(e) => {
                                    window.open(`mailto:${process.env.REACT_APP_SUPPORT_CONTACT}`, '_blank');
                                    e.preventDefault();
                                }}
                            >
                                <div style={{ width: "24px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Tooltip
                                        title={t('LJ:contactSupport')}
                                    >
                                        <div>
                                            <ContactSupportIcon />
                                        </div>
                                    </Tooltip>
                                </div>
                            </Link>
                            <IconButton
                                onClick={() => navigate('/timeline')}
                            >
                                <Tooltip
                                    title={t('LJ:myCourse')}
                                >
                                    <div>
                                        <TimelineIcon />
                                    </div>
                                </Tooltip>
                            </IconButton>
                            <AuthGuard
                                roles={userPermissions.PORTAL_LANGUAGE_CHANGE}
                                componentPermission
                            >
                                <Tooltip
                                    title={t('common:common.language')}
                                >
                                    <div>
                                        <LanguagePopover />
                                    </div>
                                </Tooltip>
                            </AuthGuard>
                        </>
                    }
                    <AccountPopover
                        sx={{
                            ml: 1,
                            "& .MuiButtonBase-root": {
                                "& .MuiTypography-root": {
                                    color: "white"
                                }
                            }
                        }}
                        showMenu={false}
                    />
                    {
                        isMobile && <IconButton
                            aria-label="mobile-menu"
                            onClick={(e) => toggleMobileMenu(e.currentTarget)}
                        >
                            <MoreVertIcon />
                        </IconButton>
                    }
                </Box>
            </Toolbar>
            {
                isMobile && <Menu
                    anchorEl={mobileMenuAnchorEl}
                    keepMounted
                    open={Boolean(mobileMenuAnchorEl)}
                    onClose={() => toggleMobileMenu(null)}
                >
                    <MenuItem onClick={() => toggleMobileMenu(null)}>
                        <Box>
                            <Link
                                component={RouterLink}
                                to="#"
                                onClick={(e) => {
                                    window.open("https://my.goodhabitz.com/sso/vieira", '_blank');
                                    e.preventDefault();
                                }}
                                sx={{
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        justifyContent: "center"
                                    }}
                                >
                                    <img
                                        style={{
                                            width: "1.2em",
                                            height: "1.2em"
                                        }}
                                        src={GoodHabitzBlack}
                                        alt="GoodHabitz"
                                    />
                                </ListItemIcon>
                                {t('LJ:GoodHabitz')}
                            </Link>
                        </Box>
                    </MenuItem>
                    <MenuItem
                        onClick={() => toggleMobileMenu(null)}
                    >
                        <Box>
                            <Link
                                component={RouterLink}
                                to="#"
                                onClick={(e) => {
                                    window.open(`mailto:${process.env.REACT_APP_SUPPORT_CONTACT}`, '_blank');
                                    e.preventDefault();
                                }}
                                sx={{
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        justifyContent: "center"
                                    }}
                                >
                                    <div style={{ width: "24px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <ContactSupportIcon />
                                    </div>
                                </ListItemIcon>
                                {t('LJ:contactSupport')}
                            </Link>
                        </Box>
                    </MenuItem>
                    <MenuItem
                        onClick={() => toggleMobileMenu(null)}
                    >
                        <Link
                            component={RouterLink}
                            to="/timeline"
                            sx={{
                                display: "flex",
                                alignItems: "center"
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    justifyContent: "center"
                                }}
                            >
                                <TimelineIcon />
                            </ListItemIcon>
                            {t('LJ:myCourse')}
                        </Link>
                    </MenuItem>
                    <AuthGuard
                        roles={userPermissions.PORTAL_LANGUAGE_CHANGE}
                        componentPermission
                    >
                        <LanguagePopover
                            toggleMobileMenu={toggleMobileMenu}
                            label={t('common:common.language')}
                        />
                    </AuthGuard>
                </Menu>
            }
        </AppBar>
    );
}

export default TopBar;
